import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { CommonButton } from "../common/commonButton";
import instance from "../../redux/api";
import { workflowBankTransaction } from "../../Services/api";
import { commonToast } from "../common";
import { ViewGenericWorkflowDialog } from "./ViewGenericWorkflowDialog";

const StepTile = ({
  step,
  isCurrentStep,
  currentWorkflowDetails,
  onClose
}) => {
  const [fieldsData, setFieldsData] = useState({
    comments: "",
  });
  const formatUsers = (users = []) =>
    users.map((u) => u.user_name).join(", ");

  const { userData } = useSelector((state) => state?.user);

  const isWorkflowInProcessAndLoggedInUserExists = () => {
    const currentUserId = userData?.id;
    const { current_step, workflow_status } = currentWorkflowDetails;
    const getWorkflowSteps = currentWorkflowDetails?.workflow_json_data?.workflow_step;

    const getCurrentStepDetails = getWorkflowSteps?.filter((item) => item?.step_name === current_step);

    let isLoggedInUserExists = false;
    if (workflow_status?.toLowerCase() === 'in process') {
      if (getCurrentStepDetails?.length === 1) {
        const currentStepUsersList = getCurrentStepDetails[0]?.user;
        const getIndex = currentStepUsersList?.findIndex(item => item?.id === currentUserId);
        // Enable comments field if logged in user is part of the current step users list
        if (getIndex != -1) {
          isLoggedInUserExists = true;
        }
      }
    }
    return isLoggedInUserExists;
  }

  const enableApproveAndRejectButtons = () => {
    return isWorkflowInProcessAndLoggedInUserExists();
  };
  const handleCommentsAreaVisibility = () => {
    return !isWorkflowInProcessAndLoggedInUserExists()
  };


  const handleInputChange = (fieldName, value) => {
    setFieldsData({
      ...fieldsData,
      [fieldName]: value,
    });
  };

  const displayAddedComments = () => {
    const currentUserId = userData?.id;
    const getWorkflowSteps =
      currentWorkflowDetails?.workflow_json_data?.workflow_step;

    let currentUserComments = "";
    for (let i = 0; i < getWorkflowSteps?.length; i++) {
      const stepInfo = getWorkflowSteps[i];
      const userInfo = stepInfo?.user;
      const getIndex = userInfo?.findIndex(
        (item) => item?.id === currentUserId
      );
      if (getIndex !== -1) {
        currentUserComments = stepInfo?.comments;
        break;
      }
    }

    return currentWorkflowDetails?.workflow_status?.toLowerCase() === "in process"
      ? currentUserComments
      : fieldsData?.comments ?? "";
  };

  useEffect(() => {
    const initialComments = displayAddedComments();
    setFieldsData((prev) => ({
      ...prev,
      comments: initialComments,
    }));
  }, [currentWorkflowDetails]);

  const handleActionButton = async (buttonType) => {
    const { id, current_step, bank_txn_id } = currentWorkflowDetails;

    const body = {
      step_name: current_step?.toLowerCase(),
      bank_txn_id: bank_txn_id,
      comments: fieldsData?.comments ?? "",
      status: buttonType,
      user_id: userData?.id,
    };

    try {
      const response = await instance.patch(
        `${workflowBankTransaction}${id}/`,
        body
      );
      if (buttonType?.toLowerCase() === "approve") {
        commonToast("success", "Workflow Approved Successfully!");
        onClose();
      } if (buttonType?.toLowerCase() === "reject") {
        commonToast("success", "Workflow Rejected successfully!");
        onClose();
      }
    } catch (err) {
      console.log(err);
      commonToast("error", "Unable to approve Workflow");
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: isCurrentStep ? "#ffffff" : "#fafafa", // White for current step
        border: isCurrentStep
          ? "2px solid #1976d2" // Blue border for current step
          : "1px solid rgb(224,224,224)",
        borderRadius: "8px",
        padding: "18px",
        marginBottom: "14px",
      }}
    >
      {/* HEADER */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" fontWeight={700}>
          {step?.step_name}
        </Typography>

        {isCurrentStep && (
          <Typography
            variant="caption"
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              px: 1,
              borderRadius: "10px",
              fontSize: "0.75rem",
            }}
          >
            Current Step
          </Typography>
        )}
      </Box>

      {/* DETAILS */}
      {step?.comments && (
        <Typography variant="body1" mt={1} fontSize="15px">
          {step?.step_name} Comments: {step?.comments}
        </Typography>
      )}
      <Typography variant="body1" fontSize="15px">
        {step?.step_name} Name: {formatUsers(step?.user)}
      </Typography>

      <Typography variant="body1" mt={1} fontSize="15px">
        Date/Time: {step?.ctime ? new Date(step?.ctime).toLocaleString() : ""}
      </Typography>

      <Typography variant="body1" mt={1} fontSize="15px">
        Status: {step?.status || "Pending"}
      </Typography>

      {/* COMMENT INPUT — ONLY CURRENT STEP */}
      {isCurrentStep && (<>
        <Box mt={2}>
          <Typography variant="subtitle2" fontWeight={600} mb={1} fontSize="14px">
            Add Comment
          </Typography>
          <textarea
            rows={4}
            style={{
              width: "70%",
              padding: "8px",
              borderRadius: "5px",
              fontFamily: "inherit",
              fontSize: "14px",
              backgroundColor: "rgb(250, 250, 250) !important"
              //   backgroundColor: disableComments ? "#afabaa" : "#ffffff",
            }}
            value={fieldsData?.comments || ""}
            disabled={handleCommentsAreaVisibility()}
            onChange={(e) => handleInputChange("comments", e.target.value)}
            placeholder="Add reason"
          />
        </Box>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          {enableApproveAndRejectButtons() && (
            <>
              <CommonButton
                text="Reject"
                hoverColor="#FF5A01"
                handleClick={() => handleActionButton("Reject")}
                disabled={!fieldsData?.comments}
              />
              <CommonButton
                text="Approve"
                hoverColor="#FF5A01"
                handleClick={() => handleActionButton("Approve")}
                disabled={!fieldsData?.comments}
              />
            </>
          )}
        </Box>
      </>
      )}
    </Box>
  );
};
const WorkStep = ({
  workflowTxnData,
  workflowSelectedName,
  currentWorkflowDetails,
  onClose,
}) => {
  if (!currentWorkflowDetails) return null;

  const steps =
    currentWorkflowDetails.workflow_json_data?.workflow_step || [];

  return (
    <Box sx={{ margin: "10px" }}>
      <Box
        sx={{
          backgroundColor: "rgb(250, 250, 250)",
          padding: "16px",
          borderRadius: "8px",
          border: "1px solid rgb(224,224,224)",
          marginBottom: "16px",
        }}
      >
        <Typography variant="body1" sx={{ width: "80%" }} fontWeight={600} fontSize="16px">
          Workflow Name: {currentWorkflowDetails.workflow_json_data.workflow_name}
        </Typography>

        <Typography variant="body1" sx={{ width: "80%" }} fontSize="15px">
          Status: {currentWorkflowDetails.workflow_status}
        </Typography>

        <Typography variant="body1" sx={{ width: "80%" }} fontSize="15px">
          Current Step: {currentWorkflowDetails.current_step}
        </Typography>
      </Box>

      {/* STEPS */}
      <ViewGenericWorkflowDialog
        workflowTxnData={workflowTxnData}
        workflowSelectedName={workflowSelectedName}
        currentWorkflowDetails={currentWorkflowDetails}
      />
      {steps.map((step, index) => (
        <StepTile
          key={index}
          step={step}
          isCurrentStep={
            step.step_name === currentWorkflowDetails.current_step
          }
          currentWorkflowDetails={currentWorkflowDetails}
          onClose={onClose}
        />
      ))}
    </Box>
  );
};

export default WorkStep;
